import React from 'react'
import { MainWorkspaceNews } from '../MainWorkspace'
import { RequireAuth } from './RequireAuth'
import { useSelector } from 'react-redux'
import { IStore } from '../../store/types'
import { CHANNELS_ID } from '../../utils/consts'

interface Props {
  element: JSX.Element
}

export const News: React.FC<Props> = ({ element }) => {
  const { users } = useSelector((store: IStore) => store)

  if (
    (users.user && !users.user.channels.includes(String(CHANNELS_ID.NEWS))) ||
    (users.user && !users.user.approved_news)
  ) {
    return null
  }

  return (
    <RequireAuth>
      <MainWorkspaceNews>{element}</MainWorkspaceNews>
    </RequireAuth>
  )
}
